const routes = [
  {
    path: 'basicAuth',
    component: () => import('@/layouts/FullPage.vue'),
    children: [
      {
        path: '',
        name: 'basicAuth',
        component: () => import('@/views/public/BasicAuth.vue'),
      },
    ],
  },
];

export default routes.map((route) => ({
  ...route,
  meta: {
    public: 'login',
  },
}));
